import { QueryClient } from '@tanstack/query-core';
import { persistQueryClient } from '@tanstack/query-persist-client-core';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import SuperJSON from 'superjson'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes (still applies to persisted data)
      gcTime: 1000 * 60 * 60 * 24, // Optional: Cache garbage collection time (e.g., 24 hours)
    },
  },
});

const localStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: 'tfpapp-query-cache', // A key for the data in localStorage
  serialize: (data) => SuperJSON.stringify(data),
  deserialize: (data) => SuperJSON.parse(data),
});


// v1 - initial version
// v2 - added SuperJSON to correctly serialize Date objects

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24 * 7, // Optional: Clear persisted cache after 7 days
  buster: 'v2', // Optional: Use this to manually bust/clear the cache on a code change
});
